import { ActionTree, GetterTree, Module, MutationTree } from "vuex"
import { RootState } from "@/store/RootStore"
import { make } from "vuex-pathify"
import { StoreUtils } from "@/utils/StoreUtils"
import services from "@/services/Services"
import { ActionType } from "@/models/ActionCode"

export const namespaced: boolean = true

export interface ActionCodeState {
    confirmed: boolean
    failed: boolean
}

function defaultState(): ActionCodeState {
    return {
        confirmed: false,
        failed: false
    }
}

export const state: ActionCodeState = defaultState()

//===================================
// Getters
//===================================
export const getters: GetterTree<ActionCodeState, RootState> = {
    ...make.getters(state)
}

//===================================
// Actions
//===================================
export const actions: ActionTree<ActionCodeState, RootState> = {
    ...make.actions(state),

    resetState({ commit }) {
        commit("resetState")
    },

    async confirmGuestInvite({ dispatch }, externalCode: string) {
        await StoreUtils.withLoading(
            dispatch,
            async () => {
                await services.actionCodes.confirm({ actionType: ActionType.GUEST_CONFIRM_ASSISTANCE, externalCode })
                dispatch("setConfirmed", true)
            },
            async () => {
                dispatch("setFailed", true)
                return true // Suppress default error toast — the page shows its own inline error message
            }
        )
    }
}

//===================================
// Mutations
//===================================
export const mutations: MutationTree<ActionCodeState> = {
    ...make.mutations(state),

    resetState(currentState: ActionCodeState) {
        Object.assign(currentState, defaultState())
    }
}

export const actionCode: Module<ActionCodeState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
}
